<script setup lang="ts">
import {onMounted, ref} from 'vue';


const emit = defineEmits<{
  (event: 'remove'): void
}>();

const isClosing = ref(false);

let timer: ReturnType<typeof setTimeout> | undefined;

onMounted(() => {
  startTimer();
});

function stopTimer() {
  clearTimeout(timer);
}

function startTimer() {
  timer = setTimeout(() => {
    isClosing.value = true;

    setTimeout(() => emit('remove'), 1000);
  }, 5000);
}

</script>

<template>
  <div
    class="toast"
    :class="{
      'toast--closing': isClosing
    }"
    @mouseenter="stopTimer"
    @mouseleave="startTimer"
  >
    <slot></slot>
  </div>
</template>

<style>
.toast {
  opacity: .75;
  transition: opacity 300ms;
  animation: toast-fade-out 5s forwards;
  background-color: rgb(var(--color-base));
}

.toast--closing {
  animation: toast-close 1s forwards;
  overflow: hidden;
  opacity: 0;
}

.toast:hover {
  opacity: 1;
  animation: none;
}

@keyframes toast-fade-out {
  0% {
    opacity: 1;
  }

  80% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

@keyframes toast-close {
  from {
    max-height: 500px;
  }

  to {
    max-height: 0px;
  }
}
</style>